import React from 'react';

export const StarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns='http://www.w3.org/2000/svg' xmlSpace='preserve' viewBox='0 0 512 512' {...props}>
        <path d='m259.216 29.942 71.054 143.977 158.89 23.088L374.185 309.08l27.145 158.23-142.114-74.698-142.112 74.698 27.146-158.23L29.274 197.007l158.891-23.088z' />
    </svg>
);
